// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zqNf","left":"styles_left__30QdS","desktopActions":"styles_desktopActions__3-HeV","title":"styles_title__20Gdh"};